import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { columns } from '@/tables/columns/vat-deadlines';
    import { Head } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import CreateVatDeadline from '@/components/vat-deadlines/CreateVatDeadline.vue';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import SystemCardMenu from '@/components/system/SystemCardMenu.vue';
    import type { BreadcrumbItem } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VatDeadlines',
  setup(__props) {

    const { hasPermission } = usePermissions();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.settings',
        },
        {
            title: 'menu.system',
            href: route('v2.vat-deadlines.index'),
        },
    ];

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.VAT_DEADLINES],
        queryFn: getVatDeadlines,
    });

    async function getVatDeadlines() {
        const { data } = await axios.get(route('v2.vat-deadlines.table'));
        return data.data;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('system.vat_deadlines_title')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, { breadcrumbs: breadcrumbs }, {
      default: _withCtx(() => [
        _createVNode(PageCard, null, {
          default: _withCtx(() => [
            _createVNode(DataTable, {
              "table-key": _unref(QueryKey).VAT_DEADLINES,
              columns: _unref(columns),
              data: _unref(data),
              loading: _unref(isPending),
              "default-column-visibility": {
                    vat_deadline_id: false,
                },
              "default-sorting": [{ id: 'vat_deadline_id', desc: true }]
            }, {
              title: _withCtx(() => [
                _createVNode(SystemCardMenu)
              ]),
              actions: _withCtx(() => [
                _createVNode(DataTableToolbarActions, { name: "vat-deadlines" }, {
                  default: _withCtx(() => [
                    (_unref(hasPermission)(_unref(Permission).SYSTEM_CREATE))
                      ? (_openBlock(), _createBlock(CreateVatDeadline, { key: 0 }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["table-key", "columns", "data", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})